<template>
  <div>
    <div class="columns has-text-centered">
      <div class="column">
        <button class="button" @click="openModal('legend')" v-show="showBtn">Show/Hide Countries</button>
        <span><button class="button" @click="clearAllCountries()" v-show="showBtn">Hide all Countries</button></span>
      </div>
    </div>
    <score-chart :chart-data="data" @Loaded="OnLoad" @Render="OnLoad"></score-chart>
  </div>
</template>
<script>
  import ScoreChart from '@/services/components/ScoreChart.vue';
  import legendModal from '@/services/components/ScoreChartCountries/legendModal.vue';
  export default {
    data() {
      return {
        data: {},
        chart: undefined
      }
    },
    components: {
      "score-chart": ScoreChart
    },
    props: {
      chartData: { Object },
      showBtn: Boolean
    },
    watch: {
      chartData: {
        handler(n, o) {
          this.data = n;
          this.Init();
          this.chart.renderChart(this.chart.chartData, this.chart.options);
        },
        deep: false
      }
    },
    methods: {
      clearAllCountries() {
        this.chart.chartData.datasets.forEach(set => {
          set.hidden = true;
        });
        this.chart.renderChart(this.chart.chartData, this.chart.options);
      },
      openModal(param) {
        var self = this;
        switch (param) {
          case "legend": {
            this.$buefy.modal.open({
              canCancel: false,
              component: legendModal,
              props: {
                datasets: this.chart.chartData.datasets
              },
              events: {
                close(datasets) {
                  self.data.datasets = datasets;
                  self.chart.renderChart(self.chart.chartData, self.chart.options)
                }
              }
            });
            break;
          }
        }
      },
      OnLoad(chart) {
        this.chart = chart;
      },
      Sort() {
        this.data.datasets.sort((a, b) => { return a.label > b.label ? 1 : -1 });
      },
      Init() {
        this.Sort();
        //Only show up to 5 by default (first 5)
        var lim = this.data.datasets.length;
        for (var i = 0; i < lim; i++) {
          if (i < 5)
            this.data.datasets[i].hidden = false;
          else
            this.data.datasets[i].hidden = true;
        }

      }
    },
    created() {
      this.data = this.chartData;
      this.Init();
    },
    mounted() {
      
    }
  }
</script>
